import {Box, Skeleton} from '@mui/material';

import {profileComparisonSectionCardSx} from './profileComparisonSectionStyles';
import {EmpionPaper} from '../../../../../components/EmpionPaper/EmpionPaper';

export const ProfileComparisonProfileGridSkeleton = () => (
  <EmpionPaper sx={profileComparisonSectionCardSx}>
    <Skeleton variant='text' width={120} height={20} sx={{mb: 1.25}} />
    <Skeleton variant='rounded' height={40} sx={{mb: 1.25}} />
    <Skeleton variant='text' width='55%' height={16} sx={{mb: 1.5}} />
    <Box sx={{display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(210px, 1fr))', gap: 1}}>
      {Array.from({length: 6}).map((_, index) => (
        <Skeleton key={index} variant='rounded' height={88} sx={{borderRadius: '8px'}} />
      ))}
    </Box>
  </EmpionPaper>
);
